import { render, staticRenderFns } from "./copy-exam-auto-rule.vue?vue&type=template&id=428d8a58&scoped=true"
import script from "./copy-exam-auto-rule.vue?vue&type=script&lang=ts"
export * from "./copy-exam-auto-rule.vue?vue&type=script&lang=ts"
import style0 from "./copy-exam-auto-rule.vue?vue&type=style&index=0&id=428d8a58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428d8a58",
  null
  
)

export default component.exports